import React from 'react';
import PropTypes from 'prop-types';

export class ProgressBar extends React.Component {
  static initClass() {
    this.propTypes =
      {percent: PropTypes.number};

    this.defaultProps =
      {percent: 0};
  }

  render() {
    return <div className="percent">
      <div className="progress_wrapper">
        <div className="progress" style={{width: `${this.props.percent  }%`}}>&nbsp;</div>
      </div>
      {this.props.children}
    </div>;
  }
}
ProgressBar.initClass();
